module.exports = __webpack_public_path__ + "fonts/Inter-BoldItalic.01c7896.woff2";